<div fxLayout="column" class="comment-component-wrapper" [ngClass]="focusingTextareaEle ? 'editor-wrapper__focused' : ''">
  <div class="comments mt-8" fxLayout="column">
    <div class="comment mb-16" fxLayout="row" fxLayoutAlign="start start" *ngFor="let comment of comments">
      <div class="comment__avatar">
        <img class="avatar w-32 h-32" [src]="comment.avatar || 'assets/images/avatars/no-avatar.png'" />
      </div>
      <div class="comment__body" fxLayout="column">
        <div class="">
          <span class="comment__body__user">{{ comment.author.userName }}</span>
          <span class="artstuff-promt-text font-size-12">{{ comment.createdDate | date: 'HH:mm dd/MM/YYYY' }}</span>
        </div>
        <div class="comment__body__detail">{{ comment.detail }}</div>
        <div class="comment__body__attachments mt-12 w-100-p">
          <div
            fxLayout="row"
            fxLayoutAlign="start center"
            class="attachment-box artstuff-pointer font-size-14 mb-12 w-100-p"
            *ngFor="let attachment of comment.attachments; let attachIdx = index"
            (click)="openPreviewAfterSend(comment, attachIdx)"
          >
            <mat-icon class="s-20" [svgIcon]="attachment.name | getFileIcon" fxFlex="20px"></mat-icon>
            <span class="ml-8 artstuff-orange-fg text-truncate text-semibold" fxFlex>{{ attachment.name }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="editor-wrapper mt-16" fxLayout="column" fxFlex [formGroup]="formGroup" #commentBox>
    <mat-form-field appearance="outline" class="editor-wrapper__comment-box w-100-p">
      <mat-label>{{ 'COMMENT.PLACEHOLDER' | translate }}</mat-label>
      <div class="editor-wrapper__content scrollable__y">
        <!-- cdkAutosizeMaxRows="15" to set the maximum height for cdk to auto-resize -->
        <textarea
          matInput
          formControlName="commentText"
          class="mb-8"
          #textarea
          maxlength="400"
          cdkTextareaAutosize
          cdkAutosizeMinRows="3"
          cdkAutosizeMaxRows="15"
          (focus)="focusingTextareaEle = true"
        ></textarea>

        <div class="editor-wrapper__attachments w-100-p" fxLayout="row wrap" fxLayoutAlign="start center">
          <div
            fxLayout="row"
            fxLayoutAlign="space-between center"
            class="attachment-box artstuff-pointer pl-16 pr-8 mb-8 w-100-p"
            *ngFor="let file of selectedFiles"
            (click)="openPreviewBeforeSend(file)"
          >
            <span fxLayout="row" fxLayoutAlign="start center" class="attachment-box__description">
              <span class="text-truncate text-semibold mr-8">{{ file.name }}</span>
              <span>({{ bytesToSize(file.size) }})</span>
            </span>
            <button mat-icon-button class="" (click)="removeAttachment(file)" fxFlex="40px">
              <mat-icon>close</mat-icon>
            </button>
          </div>
        </div>
      </div>

      <div
        class="editor-wrapper__buttons"
        fxLayout="row"
        fxLayoutAlign="end center"
        [ngClass]="{ disabled: disable === true, actived: formGroup.get('commentText').value || selectedFiles.size !== 0 }"
      >
        <span class="emoji-mart__wrapper" #emojiBox [ngClass]="showEmojiPicker ? '' : 'hide'">
          <!--
              set: 'apple' | 'google' | 'twitter' | 'facebook' | '';
              isNative="true" means using native icon. If we want to display other sets in text-area, need to do alot.
            -->
          <emoji-mart
            set=""
            *ngIf="readyToRender"
            [isNative]="true"
            class="emoji-mart"
            [darkMode]="false"
            title="Pick your emoji…"
            emoji=""
            (emojiSelect)="addEmoji($event)"
          ></emoji-mart>
        </span>
        <mat-icon
          class="artstuff-pointer"
          matTooltip="{{ 'COMMENT.ICON_EMOJI' | translate }}"
          (click)="!disable && toggleEmojiPicker(); $event.stopPropagation()"
          >mood</mat-icon
        >
        <mat-icon
          class="artstuff-pointer"
          matTooltip="{{ 'COMMENT.ICON_ATTACH' | translate }}"
          (click)="!disable && fileInput.click(); $event.stopPropagation()"
          >attach_file</mat-icon
        >
        <mat-icon
          [ngClass]="{ disabled: !formGroup.get('commentText').value && selectedFiles.size === 0 }"
          class="artstuff-pointer"
          matTooltip="{{ 'COMMENT.ICON_SEND' | translate }}"
          (click)="!disable && sendMessage(); $event.stopPropagation()"
          >send</mat-icon
        >
      </div>
      <mat-hint class="artstuff-promt-text font-size-12">{{ 'COMMENT.NOTE' | translate }}</mat-hint>
    </mat-form-field>
  </div>

  <input hidden (change)="onFileSelected($event)" #fileInput type="file" />
</div>
